import React from 'react';

import { Nullable } from '@clearverify/types';

import {
  DashboardDataDisputeItemsCountGroupByStatusInfoFragment,
  DataDisputeItemStatus,
  useGetDashboardDataDisputeItemsCountGroupedByStatusQuery,
} from 'src/api';

import { useDashboardCVAdminData } from './useDashboardCVAdminData';

export const useOverviewLastMonthDataDisputes = () => {
  const { date, peos, employers } = useDashboardCVAdminData();

  const { data, loading } = useGetDashboardDataDisputeItemsCountGroupedByStatusQuery({
    variables: {
      peoIds: peos?.map(peo => peo.id),
      employerIds: employers?.map(employer => employer.id),
      asOfDate: date.toISO(),
    },
  });

  const lastMonthDataDisputes = React.useMemo(() => {
    return {
      [DataDisputeItemStatus.Resolved]: getGroupedDataDisputeItemsCount(
        data?.getDashboardDataDisputeItemsCountGroupedByStatus,
        DataDisputeItemStatus.Resolved,
      ),
      [DataDisputeItemStatus.InProgress]: getGroupedDataDisputeItemsCount(
        data?.getDashboardDataDisputeItemsCountGroupedByStatus,
        DataDisputeItemStatus.InProgress,
      ),
    };
  }, [data]);

  return { lastMonthDataDisputes, lastMonthDataDisputesLoading: loading };
};

const getGroupedDataDisputeItemsCount = (
  groups: Nullable<DashboardDataDisputeItemsCountGroupByStatusInfoFragment[]>,
  status: DataDisputeItemStatus,
) => {
  return groups?.find(group => group.status === status)?.count || 0;
};
